// POS = rendering context
// PAS un produit
// PAS un workflow
// PAS une vue métier
//
// Provider global du displayContext.
// useDisplayContext() doit toujours retourner un objet valide, même sans provider :
// fallback automatique vers defaultDisplayContext.

import React, { createContext, useContext, useMemo } from 'react';
import { defaultDisplayContext } from '../utils/displayContext';

const DisplayContext = createContext(defaultDisplayContext);

export const DisplayContextProvider = ({ value, children }) => {
  const safeValue = useMemo(() => {
    if (!value || typeof value !== 'object') return defaultDisplayContext;
    return { ...defaultDisplayContext, ...value };
  }, [value]);

  return (
    <DisplayContext.Provider value={safeValue}>
      {children}
    </DisplayContext.Provider>
  );
};

export function useDisplayContext() {
  const ctx = useContext(DisplayContext);
  return ctx || defaultDisplayContext;
}

export default DisplayContextProvider;
